// extracted by mini-css-extract-plugin
module.exports = {"icon":"Sbzyj","reversedIcon":"_3D1Cr","overflow":"_3maIr","title":"_1idsK","mobile":"EOok-","listContentTitleColor":"_2Rnds"};